<template>
  <div class="analysis">
    <div class="analysis-top">
      <div class="analysis-top__name">销售趋势分析</div>
      <div class="analysis-top-fun">
        <div class="analysis-top-item">
          <el-select size="mini" placeholder="所有国家"></el-select>
        </div>
        <div class="analysis-top-item">
          <el-select size="mini" placeholder="所有店铺"></el-select>
        </div>
        <div class="analysis-top-item">
          <el-select size="mini" placeholder="所有产品"></el-select>
        </div>
        <div class="analysis-top-item">
          <el-select size="mini" placeholder="销量趋势"></el-select>
        </div>
        <div class="analysis-top-item">
          <el-select size="mini" placeholder="2022年"></el-select>
        </div>
        <div class="analysis-top-item">
          <el-select size="mini" placeholder="按月统计"></el-select>
        </div>
        <div class="analysis-top__btn">搜索</div>
      </div>
    </div>
    <div class="analysis-menu">
      <div class="analysis-menu-item"
        v-for="item in menuData"
        @click="clickMenuItem(item.id)"
        :class="{'analysis-menu-item--select': selectMenu.includes(item.id)}"
        :key="item.id">{{ item.name }}</div>
    </div>
    <div class="analysis-echart" id="lineSmoothAnalysis">echart</div>
  </div>
</template>

<script>
import { AnalysisSearchData, AnalysisNewModule } from './class'
export default {
  name: 'salesTrendAnalysis',
  data(){
    return {
      /**搜索数据 */
      searchData: new AnalysisSearchData(),
      /**菜单 */
      menuData: AnalysisNewModule.NEWMANUITEM(),
      selectMenu: ['orderNum', 'salesNum', 'salesPrice', 'profitRate'],
      /**分析图数据 */
      analysisEchartsData: AnalysisNewModule.EchartsDefaultData()
    }
  },
  mounted(){
    this.drawEcharts()
  },
  methods: {
    /**菜单子项点击事件 */
    clickMenuItem(id){
      if(this.selectMenu.includes(id)){
        this.selectMenu = this.selectMenu.filter(item => item != id)
      }else{
        this.selectMenu.push(id)
      }
    },
    /**绘制图表 */
    drawEcharts(){
      let line = this.$echarts.init(document.getElementById('lineSmoothAnalysis'))
      line.setOption(this.analysisEchartsData)
    }
  }
}
</script>

<style lang="scss" scoped>
.analysis{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
    &-fun{
      display: flex;
      align-items: center;
    }
    &-item{
      display: flex;
      align-items: center;
      // width: 120px;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 120px;
        }
        .el-input{
          width: 120px;
        }
      }
      &__name{
        border: 1px solid #cecece;
        width: 90px;
        height: 28px;
        line-height: 28px;
        text-align: center;
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 300px;
          }
          .el-input{
            width: 300px;
          }
        }
      }

    }
    &__btn{
      line-height: 30px;
      padding: 0 30px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
  &-menu{
    width: 1780px;
    margin: 5px auto;
    display: flex;
    border-bottom: 2px solid #eeeeee;
    &-item{
      width: 150px;
      text-align: center;
      line-height: 30px;
      margin-right: 5px;
      border: 1px solid #eeeeee;
      background: #fafafa;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
      &--select{
        background: #00a0c7;
        color: white;
      }
    }
  }
  &-echart{
    height: 500px;
  }
}
</style>
